// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","about":"about_about__TPRzg","container":"about_container__F7oAN","aboutInner":"about_aboutInner__cMRkm","btns":"about_btns__ujiRB"};